import { consoleEvents, getLabelFromStorage } from '@pb/utils'
import { batch } from 'redux-act'

import { PAYMENT_SECTION_SYSTEM_ERROR } from 'constants/optimizely'
import {
  TECHNICAL_ERROR_LABELS,
  SHOW_NOTIFICATION_TIME,
  CHECKOUT_TRACKING_SECTIONS,
  CHECKOUT_TRACKING_ERROR_TYPES,
} from 'features/checkout/constants'
import {
  setSelectedPaymentMethod,
  patchPaymentStart,
  patchPaymentFail,
  patchPaymentSuccess,
} from 'features/checkout/duck/actions'
import { normalizeContextPartial } from 'features/checkout/duck/normalize'
import { patchCheckoutPayment } from 'features/checkout/requests'
import {
  AdyenPaymentDataForNewCard,
  AdyenPaymentDataForSavedCard,
  CybersourcePaymentDataForNewCard,
  CybersourcePaymentDataForSavedCard,
  PaymentMode,
} from 'features/checkout/types'
import { showNotification } from 'features/notifications/duck/actions'
import getErrorData from 'helpers/getErrorData'
import { trackOptimizelyEvent } from 'helpers/optimizely'
import { ThunkResult } from 'redux/types'

import { trackError } from './track'

export const operationSelectPaymentMethod =
  (
    paymentMode: PaymentMode,
    additionalData?:
      | AdyenPaymentDataForNewCard
      | AdyenPaymentDataForSavedCard
      | CybersourcePaymentDataForNewCard
      | CybersourcePaymentDataForSavedCard,
  ): ThunkResult<Promise<void>> =>
  async (dispatch) => {
    dispatch(patchPaymentStart())
    try {
      const paymentResponse = await patchCheckoutPayment(paymentMode.code)
      const normalizedPayment = dispatch(normalizeContextPartial({ ...paymentResponse }))

      dispatch(
        patchPaymentSuccess({
          ...normalizedPayment,
          newPaymentState: { ...normalizedPayment.payment, ...additionalData },
        }),
      )
      dispatch(setSelectedPaymentMethod(paymentMode))
    } catch (error) {
      consoleEvents.error('Failed to select payment method', error)
      const { code } = getErrorData(error)
      const errorMessage = getLabelFromStorage(TECHNICAL_ERROR_LABELS.selectPayment)
      dispatch(
        batch(
          patchPaymentFail(),
          showNotification({
            content: errorMessage,
            type: 'error',
            timespan: SHOW_NOTIFICATION_TIME,
          }),
        ),
      )
      dispatch(
        trackError({
          section: CHECKOUT_TRACKING_SECTIONS.payment,
          message: errorMessage,
          id: code,
          errorType: CHECKOUT_TRACKING_ERROR_TYPES.system,
        }),
      )
      trackOptimizelyEvent(PAYMENT_SECTION_SYSTEM_ERROR)
    }
  }
